/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {QuestionAnswer} from './QuestionAnswer';

/**
 * The InlineResponse20119 model module.
 * @module model/InlineResponse20119
 * @version 1.0.0
 */
export class InlineResponse20119 {
  /**
   * Constructs a new <code>InlineResponse20119</code>.
   * @alias module:model/InlineResponse20119
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse20119</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20119} obj Optional instance to populate.
   * @return {module:model/InlineResponse20119} The populated <code>InlineResponse20119</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20119();
      if (data.hasOwnProperty('data'))
        obj.data = QuestionAnswer.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {module:model/QuestionAnswer} data
 */
InlineResponse20119.prototype.data = undefined;

